function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * 菜单
 * */
import { cloneDeep } from 'lodash';
import { getBreadCrumbList, setTagNavListInLocalstorage,
// getMenuByRouter,
getTagNavListFromLocalstorage, getHomeRoute, getNextRoute, routeHasExist, routeEqual, getRouteTitleHandled, localSave, localRead } from '@/utils/util';
import router from '@/router';

// import { includeArray } from '@/utils/system.js';
var homeName = 'Dashboard';
// 根据 menu 配置的权限，过滤菜单
function filterMenu(menuList, access, lastList) {
  menuList.forEach(function (menu) {
    var menuAccess = menu.auth;
    if (!menuAccess || includeArray(menuAccess, access)) {
      var newMenu = {};
      for (var i in menu) {
        if (i !== 'children') newMenu[i] = cloneDeep(menu[i]);
      }
      if (menu.children && menu.children.length) newMenu.children = [];
      lastList.push(newMenu);
      menu.children && filterMenu(menu.children, access, newMenu.children);
    }
  });
  return lastList;
}
// 递归处理顶部菜单问题
function getChilden(data) {
  if (data.children) {
    return getChilden(data.children[0]);
  }
  return data.path;
}
// 获取表单页面的标题
function getFormTitle(router) {
  var path = router.path;
  var index = path.lastIndexOf('/');
  path = path.substring(index + 1, path.length);
  switch (path) {
    case 'shop_tabs':
      return '商城设置';
      break;
    case 'pay_tabs':
      return '支付设置';
      break;
    case 'smallapp':
      return '小程序配置';
      break;
    case 'wechat':
      return '公众号配置';
      break;
    case 'wechat_open_app':
      return 'app配置';
      break;
    case 'app_version':
      return 'app升级配置';
      break;
    case 'pc_config':
      return 'pc基础配置';
      break;
    case 'pc_config':
      return 'pc基础配置';
      break;
    default:
      return router.meta.title;
  }
}
var closePage = function closePage(state, route) {
  var nextRoute = getNextRoute(state.tagNavList, route);
  state.tagNavList = state.tagNavList.filter(function (item) {
    return !routeEqual(item, route);
  });
  router.push(nextRoute);
};
export default {
  namespaced: true,
  state: {
    // 顶部菜单
    header: [],
    // 一级菜单名称
    oneMenuName: '',
    // 侧栏菜单
    sider: [],
    // 当前顶栏菜单的 name
    headerName: '',
    // 当前所在菜单的 path
    activePath: '',
    // 展开的子菜单 name 集合
    openNames: [],
    //----------------------------------------------------------------
    breadCrumbList: [],
    tagNavList: getTagNavListFromLocalstorage() || [],
    homeRoute: {},
    local: localRead('local'),
    errorList: [],
    adminTitle: '',
    hasReadErrorPage: false,
    //----------------------------------------------------------------
    keepAliveNames: []
  },
  getters: {
    /**
     * @description 根据 user 里登录用户权限，对侧边菜单进行鉴权过滤
     * */
    filterSider: function filterSider(state, getters, rootState) {
      var userInfo = rootState.user.info;
      // @权限
      var access = userInfo.access;
      if (access && access.length) {
        return filterMenu(state.sider, access, []);
      } else {
        return filterMenu(state.sider, [], []);
      }
    },
    // 处理顶部路由递归
    /**
     * @description 根据 user 里登录用户权限，对顶栏菜单进行鉴权过滤
     * */
    filterHeader: function filterHeader(state, getters, rootState) {
      //  调用递归函数
      state.header.forEach(function (item) {
        item.path = getChilden(item);
      });

      // @权限
      var userInfo = rootState.admin.user.info;
      var access = userInfo.access;
      if (access && access.length) {
        return state.header.filter(function (item) {
          var state = true;
          if (item.auth && !includeArray(item.auth, access)) state = false;
          return state;
        });
      } else {
        return state.header.filter(function (item) {
          var state = true;
          if (item.auth && item.auth.length) state = false;
          return state;
        });
      }
    },
    /**
     * @description 当前 header 的全部信息
     * */
    currentHeader: function currentHeader(state) {
      return state.header.find(function (item) {
        return item.name === state.headerName;
      });
    },
    /**
     * @description 在当前 header 下，是否隐藏 sider（及折叠按钮）
     * */
    hideSider: function hideSider(state, getters) {
      var visible = false;
      if (getters.currentHeader && 'hideSider' in getters.currentHeader) visible = getters.currentHeader.hideSider;
      return visible;
    }
  },
  mutations: {
    /**
     * @description 设置侧边栏菜单
     * @param {Object} state vuex state
     * @param {Array} menu menu
     */
    setSider: function setSider(state, menu) {
      state.sider = menu;
    },
    /**
     * @description 设置侧边栏菜单
     * @param {Object} state vuex state
     * @param {Array} menu menu
     */
    setOpenMenuName: function setOpenMenuName(state, menu) {
      state.oneMenuName = menu;
    },
    /**
     * @description 设置顶栏菜单
     * @param {Object} state vuex state
     * @param {Array} menu menu
     */
    setHeader: function setHeader(state, menu) {
      state.header = menu;
    },
    /**
     * @description 设置当前顶栏菜单 name
     * @param {Object} state vuex state
     * @param {Array} name headerName
     */
    setHeaderName: function setHeaderName(state, name) {
      state.headerName = name;
    },
    /**
     * @description 设置当前所在菜单的 path，用于侧栏菜单高亮当前项
     * @param {Object} state vuex state
     * @param {Array} path fullPath
     */
    setActivePath: function setActivePath(state, path) {
      state.activePath = path;
    },
    /**
     * @description 设置当前所在菜单的全部展开父菜单的 names 集合
     * @param {Object} state vuex state
     * @param {Array} names openNames
     */
    setOpenNames: function setOpenNames(state, names) {
      state.openNames = names;
    },
    getCacheKeepAlive: function getCacheKeepAlive(state, data) {
      state.keepAliveNames = data;
    },
    // ----------------------------------------------------------------
    setBreadCrumb: function setBreadCrumb(state, route) {
      state.breadCrumbList = getBreadCrumbList(route, state.homeRoute);
    },
    setAdminTitle: function setAdminTitle(state, title) {
      state.adminTitle = title;
    },
    setHomeRoute: function setHomeRoute(state, routes) {
      state.homeRoute = getHomeRoute(routes, homeName);
    },
    setTagNavList: function setTagNavList(state, list) {
      var tagList = [];
      if (list.length) {
        tagList = _toConsumableArray(list);
      }
      state.tagNavList = tagList;
      setTagNavListInLocalstorage(_toConsumableArray(tagList));
    },
    closeTag: function closeTag(state, route) {
      var tag = state.tagNavList.filter(function (item) {
        return routeEqual(item, route);
      });
      route = tag[0] ? tag[0] : null;
      if (!route) return;
      closePage(state, route);
    },
    addTag: function addTag(state, _ref) {
      var route = _ref.route,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? 'unshift' : _ref$type;
      var router = getRouteTitleHandled(route);
      router.meta.title = getFormTitle(router);
      var i = state.tagNavList.findIndex(function (item) {
        return item.path === route.path;
      });
      if (!routeHasExist(state.tagNavList, router)) {
        if (type === 'push') if (i < 1) state.tagNavList.push(router);else {
          return;
          // if (router.name === homeName) state.tagNavList.unshift(router);
          // else state.tagNavList.splice(1, 0, router);
        }
        setTagNavListInLocalstorage(_toConsumableArray(state.tagNavList));
      }
    },
    setLocal: function setLocal(state, lang) {
      localSave('local', lang);
      state.local = lang;
    },
    addError: function addError(state, error) {
      state.errorList.push(error);
    },
    setHasReadErrorLoggerStatus: function setHasReadErrorLoggerStatus(state) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      state.hasReadErrorPage = status;
    },
    clearAll: function clearAll(state) {
      state.tagNavList = [];
    },
    // 关闭tab标签页,跳入指定页面
    closePageTagsView: function closePageTagsView(state, path, goBackPath) {
      state.tagNavList.map(function (v, k, arr) {
        if (!v.meta.isAffix) {
          if (v.path === path) {
            state.tagNavList.splice(k, 1);
            setTimeout(function () {
              router.push({
                path: goBackPath
              });
            }, 0);
          }
        }
      });
    }
  },
  actions: {
    addErrorLog: function addErrorLog(_ref2, info) {
      var commit = _ref2.commit,
        rootState = _ref2.rootState;
      if (!window.location.href.includes('error_logger_page')) commit('setHasReadErrorLoggerStatus', false);
      var _rootState$user = rootState.user,
        token = _rootState$user.token,
        userId = _rootState$user.userId,
        userName = _rootState$user.userName;
      var data = _objectSpread(_objectSpread({}, info), {}, {
        time: Date.parse(new Date()),
        token: token,
        userId: userId,
        userName: userName
      });
      // saveErrorLogger(info).then(() => {
      //   commit('addError', data)
      // })
    },
    // 设置路由缓存（name字段）
    setCacheKeepAlive: function () {
      var _setCacheKeepAlive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref3, data) {
        var commit;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              commit = _ref3.commit;
              commit('getCacheKeepAlive', data);
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function setCacheKeepAlive(_x, _x2) {
        return _setCacheKeepAlive.apply(this, arguments);
      }
      return setCacheKeepAlive;
    }()
  }
};